var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from "react";
import React from 'react';
export const QRPrompt = ({ qrCode, setQrCode, protectedQrState, qrCodeBankId }) => {
    useEffect(() => {
        const handle = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield qrCodeBankId(protectedQrState);
            setQrCode(response.qrCode);
        }), 1000);
        return () => clearTimeout(handle);
    }, [qrCode]);
    return (React.createElement(React.Fragment, null, qrCode &&
        React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
            React.createElement("img", { style: { width: '20rem', height: '20rem' }, src: 'data:image/png;base64, ' + qrCode, alt: "QR Code" }))));
};
